module.exports = __webpack_public_path__ + "img/Group 1000005946.e1bd6174.png";